import { AppConfig } from './../../app.config';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { GetRecordModificationsRequest, RecordModification, UpdateRecordModificationsRequest, UserProfileOperations, WebApiEndpoints } from '@liquitics/transaction';
import { AwsUtil } from '../../authentication/aws.service';


@Component({
    selector: 'app-record-modifications',
    templateUrl: './record-modifications.component.html',
    styleUrls: ['./record-modifications.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RecordModificationsComponent implements OnInit, OnDestroy {

    currentUsername: string;
    profile: UserProfileOperations;

    customerManagedRecordModifications: RecordModification[];
    selectedCustomerManagedRecordModifications: RecordModification[];
    infoRecordModification: RecordModification;
    comments: string;

    showSubmitDialog = false;
    showApproveDialog = false;
    showRejectDialog = false;
    showInfo = false;
    loading = false;

    constructor(private awsUtil: AwsUtil, private appConfig: AppConfig) {
        this.currentUsername = this.awsUtil.cognitoUtil.getCurrentUser().getUsername();
        this.profile = this.appConfig.activeUserProfile as UserProfileOperations;

    }

    async refreshRecordModifications() {
        this.loading = true;
        try {
            this.customerManagedRecordModifications =
                (await this.awsUtil.webAPICall<RecordModification[]>(WebApiEndpoints.QueryRecordModifications,
                    {
                        category: 'CUSTOMER_MANAGED_DATA',
                    } as GetRecordModificationsRequest))
                    .map((rm: any) => {
                        rm.itemLocation = rm.itemLocation.split('/').splice(1).join('/');
                        return rm;
                    })
                ;
        } catch (err) {
            console.log(err);
        } finally {
            this.loading = false;
        }
    }

    async ngOnInit() {
        await this.refreshRecordModifications();
    }

    ngOnDestroy() {
    }


    onSubmit() {
    }


    async onActionConfirm(updateType: string) {
        await this.awsUtil.webAPICall<RecordModification[]>(WebApiEndpoints.UpdateRecordModifications,
            {
                itemKeys: this.selectedCustomerManagedRecordModifications.map((m) => m.itemKey),
                updateType,
                user: this.currentUsername,
                comment: this.comments,
            } as UpdateRecordModificationsRequest, true);

        this.showSubmitDialog = false;
        this.showApproveDialog = false;
        this.showRejectDialog = false;
        this.comments = undefined;
        await this.refreshRecordModifications();
    }

    async onSubmitConfirm() {
        await this.onActionConfirm('SUBMIT');
    }

    async onApproveConfirm() {
        await this.onActionConfirm('APPROVE');
    }

    async onRejectConfirm() {
        await this.onActionConfirm('REJECT');
    }

    onInfo(record: RecordModification) {
        this.infoRecordModification = record;
        this.showInfo = true;
    }
    onLink(record: RecordModification) {
        const itemKeySplits = record.itemKey.split('/');
        const url = `https://s3.console.aws.amazon.com/s3/object/${itemKeySplits[2]}?prefix=${itemKeySplits.slice(3).join('/')}`;
        window.open(url, '_blank');
    }

    updateEnabled(status: string) {
        if (this.selectedCustomerManagedRecordModifications && this.selectedCustomerManagedRecordModifications.length > 0) {
            const statusCount = this.selectedCustomerManagedRecordModifications
                .filter((rm) => {
                    return rm.status === status;
                })
                .filter((rm) => {
                    if (status === 'PENDING') {
                        // if (this.profile.)
                        // Can't approve/reject your own unless you are admin
                        return rm.submitUser !== this.currentUsername;
                    }
                })
                .length;
            return statusCount === this.selectedCustomerManagedRecordModifications.length;
        }
        return false;
    }

    submitEnabled() {
        return this.updateEnabled('MODIFIED');
    }
    approveEnabled() {
        return this.updateEnabled('PENDING');
    }
    rejectEnabled() {
        return this.updateEnabled('PENDING');
    }
}